import React from 'react';

export default () => <div className="outside-handler-exception" style={{ display: 'none' }} />;
